<template>
    <div>
        <div v-if="loaded" class="product-grid product-grid__wrapper">
            <div v-for="item in store.methods.itemsInLinje(this)" :key="item.id" class="product-grid product-grid__product product-grid__product--tillval" :class="[(store.state.numberOfProductsFor2xGrid.includes(numberOfFilteredItems)) ? 'product-grid__product--two-grid' : 'product-grid__product--three-grid']">
                <div class="product-grid product-grid__image-container product-grid__image-container--tillval" @click="store.methods.chooseProduct(item, this)">
                    <div class="product-grid__image-box" :class="[ store.methods.getCheckmarkClass(item, this, false, false, true), store.methods.getImageClass('product-grid__image-box--', this) ]">
                        <div class="product-grid__inner-image-wrapper" :class="store.methods.getImageClass('product-grid__inner-image-wrapper--', this)">
                            <img :src="store.methods.getImage(item.id, imageLayout, this)" draggable="false" class="product-grid product-grid__image" :class="store.methods.getImageClass('product-grid__image--', this)">
                        </div>
                    </div>
                </div>
                <div class="product-grid product-grid__title product-grid__title--tillval" :class="[(chosenProductIds.includes(item.id, 0) ) ? 'product-grid__title--active' : '']">
                    <p class="product-grid product-grid__title-text" :class="[(chosenProductIds.includes(item.id, 0) ) ? 'product-grid__title-text--active' : '']">{{item.name}}</p>
                    <div class="tillval tillval__wrapper" :class="[(chosenProductIds.includes(item.id, 0) ) ? 'tillval__wrapper--active' : '']">
                        <div class="tillval tillval__text-wrapper">
                            <p class="tillval tillval__text" :class="[(chosenProductIds.includes(item.id, 0) ) ? 'tillval__text--active' : '']">Antal</p>
                        </div>
                        <div class="tillval tillval__button-wrapper">
                            <div class="tillval tillval__button" @click="decrement(item, store, this)" :class="[(chosenProductIds.includes(item.id, 0) ) ? 'tillval__button--active' : '']">
                                –
                            </div>
                            <p class="tillval tillval__number" :class="[(chosenProductIds.includes(item.id, 0) ) ? 'tillval__number--active' : '']">{{item.itemCounter}}</p>
                            <div class="tillval tillval__button" @click="increment(item, store, this)" :class="[(chosenProductIds.includes(item.id, 0) ) ? 'tillval__button--active' : '']">
                                +
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!loaded" class="loading loading__wrapper">
        </div>
    </div>
</template>

<script>

import { inject } from 'vue';

export default {
    name: 'Tillval',
    setup() {
        const store = inject('store');
        return {
            store
        }
    },
    data() {
        return {
            chosenProductIds: [],
            productCounter: new Map(),
            items: [],
            loaded: false,
            dummy: '',
            numberOfFilteredItems: 0
        }
    },
    props: {
        endpoint: String,
        imageLayout: String,
    },
    mounted() {
        const store = inject('store');
        store.state.tillvalEndpoint = this.endpoint;
        this.fetchData(store);
    },
    methods: {
        async fetchData(store) {
            let fetchEndpoint = store.state.woocommerceEndpoint + this.endpoint + "/?consumer_key=ck_8f1501db1eb324953898abe1de1026e86ea31ade&consumer_secret=cs_4fc9b2265b651395737ee4d989d4ccb50f235332";
            let items = await store.methods.fetchProductData(fetchEndpoint);
            this.items = JSON.parse(items);
            for (const item of this.items) {
                item.itemCounter = 0;
            }
            this.loaded = true;
            store.methods.setStepAsLoaded(this);
        },
        increment(product, store, component) {
            product.itemCounter++;
            if (product.itemCounter == 1) {
                store.methods.chooseProduct(product, component);
            } else {
                store.methods.updateStateProducts(product, component, "add");
            }
        },
        decrement(product, store, component) {
            if (product.itemCounter > 0) {
                product.itemCounter--;
                if (product.itemCounter == 0) {
                    store.methods.chooseProduct(product, component);
                } else {
                    store.methods.updateStateProducts(product, component, "add");
                }
            }
        },
        updateChosenProductCheckmark(action) {
            if (this.chosenProductIds.length > 0) {
                this.$emit('updateChosenProductCheckmark', "add")
            } else {
                this.$emit('updateChosenProductCheckmark', "remove")
            }
        }
    }
}
</script>
